/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled, { css } from "styled-components";
import { Box, theme } from "@nordcloud/gnui";
import { ResourceUpdateStatus } from "../../types";

const getClickableStyles = ({ $clickable }: { $clickable?: boolean }) =>
  $clickable &&
  css`
    cursor: pointer;
    &:hover {
      background: ${theme.color.background.ui04};
    }
  `;

const getActiveStyles = ({ $active }: { $active?: boolean }) =>
  $active &&
  css`
    border: 1px solid ${theme.color.border.border02};
    background: ${theme.color.background.ui04};
  `;

export const CardContainer = styled(Box)<{
  status: ResourceUpdateStatus;
  $clickable?: boolean;
  $active?: boolean;
  hideBorderTop?: boolean;
}>`
  position: relative;
  border: 1px solid ${theme.color.border.border01};
  background: ${theme.color.background.ui03};
  border-radius: ${theme.radius.lg};
  padding: ${theme.spacing.spacing03};
  min-width: 200px;
  transition: none;

  ${getClickableStyles}
  ${getActiveStyles}
`;

export const StatusBorder = styled.div<{ color: string }>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: ${theme.spacing.spacing01};
  background-color: ${(props) => props.color};
  border-top-left-radius: ${theme.radius.md};
  border-top-right-radius: ${theme.radius.md};
`;
